export const SEARCH_QUERY_PARAM_KEY = 'q';
